export default "/_next/static/images/8df7dc23ef13a4f1e2d5fa21aa531aac.jpg";